module.exports = __webpack_public_path__ + "img/Syaman_K_G.07f94276.jpeg";